import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import AftersalesCard from "../../cards/AftersalesCard/AftersalesCard";
import aftersalesData from "../../../data/aftersalesData";
import aftersalesBg from "../../../assets/images/aftersalesBanner.png"; // background banner image
import "./AftersalesSupportSection.css";

export default function AftersalesSupportSection() {
    return (
        <section
            className="aftersales-section section-spacing"
            style={{
                backgroundImage: `linear-gradient(120deg, rgba(60, 42, 152,0.78)), url(${aftersalesBg})`
            }}
        >
            <Container fluid="lg">
                <Row className="align-items-center">
                    {/* Column 1: Title, text, quote */}
                    <Col xs={12} lg={6} className="mb-4 mb-lg-0">
                        <div className="aftersales-section__content">
                            <SectionTitle className="text-white mb-3"
                                subtitle="Aftersales Support"
                                title="We Stay With You Beyond the Purchase"
                            />
                            <p className="aftersales-section__text">
                                LANDKING KSA stands beside every truck that rolls out on Saudi
                                roads. From scheduled maintenance to emergency breakdown support,
                                our teams ensure your fleet keeps moving and your business
                                doesn’t stop.
                            </p>
                            <p className="aftersales-section__quote">
                                “You don’t just buy a LANDKING truck. You gain a long-term
                                support partner committed to your uptime.”
                            </p>
                        </div>
                    </Col>

                    {/* Column 2: Aftersales cards */}
                    <Col xs={12} lg={6}>
                        <div className="aftersales-section__cards">
                            {aftersalesData.map((item) => (
                                <AftersalesCard
                                    key={item.id}
                                    imageSrc={item.imageSrc}
                                    subtitle={item.subtitle}
                                />
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
